(function(){
  const youbi = ["日","月","火","水","木","金","土"];
  const pad = (n)=> String(n).padStart(2,"0");
  const ymd = (y,m,d)=> `${y}-${pad(m+1)}-${pad(d)}`;

  function setupCalendars(){
    // ページ内に対象が無ければ何もしない
    const el0 = document.getElementById("asf-cal-0");
    const el1 = document.getElementById("asf-cal-1");
    if(!el0 || !el1) return;

    // ★ 休業日設定（ここだけ編集OK）
const closedDates = [
  "2026-01-01", // 元日
  "2026-01-12", // 成人の日

  "2026-02-11", // 建国記念の日
  "2026-02-23", // 天皇誕生日

  "2026-03-20", // 春分の日

  "2026-04-29", // 昭和の日

  "2026-05-03", // 憲法記念日
  "2026-05-04", // みどりの日
  "2026-05-05", // こどもの日
  "2026-05-06", // 休日（振替等）

  "2026-07-20", // 海の日

  "2026-08-11", // 山の日

  "2026-09-21", // 敬老の日
  "2026-09-22", // 休日
  "2026-09-23", // 秋分の日

  "2026-10-12", // スポーツの日

  "2026-11-03", // 文化の日
  "2026-11-23", // 勤労感謝の日
];

    const weeklyClosed = [0, 6
      // 例：毎週日曜休みなら 0
      // 0
    ];

    function isClosed(y,m,d){
      const key = ymd(y,m,d);
      const w = new Date(y,m,d).getDay();
      return closedDates.includes(key) || weeklyClosed.includes(w);
    }

    function renderMonth(targetEl, baseDate){
      const y = baseDate.getFullYear();
      const m = baseDate.getMonth();
      const first = new Date(y,m,1);
      const last  = new Date(y,m+1,0).getDate();
      const startWeek = first.getDay();

      let html = `<p class="asf-calmonth">${y}年 ${m+1}月</p>`;
      html += `<table class="asf-caltable" aria-label="${y}年${m+1}月のカレンダー"><thead><tr>`;
      for(const d of youbi){ html += `<th scope="col">${d}</th>`; }
      html += `</tr></thead><tbody><tr>`;

      for(let i=0;i<startWeek;i++){ html += `<td class="asf-empty"></td>`; }

      for(let day=1; day<=last; day++){
        const w = new Date(y,m,day).getDay();
        const cls = isClosed(y,m,day) ? "asf-closed" : "";
        html += `<td class="${cls}" aria-label="${y}年${m+1}月${day}日">${day}</td>`;
        if(w === 6 && day !== last){ html += `</tr><tr>`; }
      }

      const endWeek = new Date(y,m,last).getDay();
      for(let i=endWeek+1;i<=6;i++){ html += `<td class="asf-empty"></td>`; }

      html += `</tr></tbody></table>`;
      targetEl.innerHTML = html;
    }

    const today = new Date();
    const thisMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const nextMonth = new Date(today.getFullYear(), today.getMonth()+1, 1);
    renderMonth(el0, thisMonth);
    renderMonth(el1, nextMonth);
  }

  // DOM生成後に確実に実行
  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", setupCalendars);
  }else{
    setupCalendars();
  }
})();
